import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { ComboListComponent } from '@farris/ui-combo-list';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[comboListRef]'
})
export class ComboListComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: ComboListComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }
}